// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_1sRI4","addToCalendarHidden":"_1YiXa"};